/**
 * Firebase web config for Zunelo (public client identifiers — not secrets).
 * Override via VITE_FIREBASE_* when needed; defaults target project studio-1282797768-e569c.
 */

import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';

const firebaseConfig = {
  apiKey:
    import.meta.env.VITE_FIREBASE_API_KEY ??
    'AIzaSyB7pB3iEZLoIUzMu5v770xdsOompWEMT3I',
  // Brand consent host. Requires Google Cloud OAuth web client redirect URI
  // https://zunelo.web.app/__/auth/handler (APIs & Services → Credentials).
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'zunelo.web.app',
  projectId:
    import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'studio-1282797768-e569c',
  appId:
    import.meta.env.VITE_FIREBASE_APP_ID ??
    '1:480819265604:web:a98e16ede3643a0e28fc11',
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '480819265604',
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ??
    'studio-1282797768-e569c.firebasestorage.app',
};

let app: FirebaseApp | undefined;
let auth: Auth | undefined;

export function getFirebaseApp(): FirebaseApp {
  if (!app) {
    app = initializeApp(firebaseConfig);
  }
  return app;
}

export function getFirebaseAuth(): Auth {
  if (!auth) {
    auth = getAuth(getFirebaseApp());
  }
  return auth;
}

export { firebaseConfig };
